import { render, staticRenderFns } from "./applyRecord.vue?vue&type=template&id=5f217d12&scoped=true&"
import script from "./applyRecord.vue?vue&type=script&lang=js&"
export * from "./applyRecord.vue?vue&type=script&lang=js&"
import style0 from "./applyRecord.vue?vue&type=style&index=0&id=5f217d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f217d12",
  null
  
)

component.options.__file = "applyRecord.vue"
export default component.exports